import { Grid } from "@material-ui/core";
import CustomTimePickerInput from "./CustomTimePickerInput";
import React, { useEffect, useState } from "react";
import { useField } from "react-final-form";
import { isValidTimeRangeValidation } from "utils/validation";

interface ICustomTimeRangeInput {
  toSource: string;
  fromSource: string;
  toLabel?: string;
  fromLabel?: string;
}

const CustomTimeRangeInput = ({
  toSource,
  fromSource,
  toLabel,
  fromLabel,
}: ICustomTimeRangeInput) => {
  const [isError, setIsError] = useState(false);

  const fromTime = useField(fromSource);
  const toTime = useField(toSource);

  useEffect(() => {
    if (fromTime.input.value && toTime.input.value) {
      setIsError(
        !isValidTimeRangeValidation(fromTime.input.value, toTime.input.value),
      );
    } else {
      setIsError(false);
    }
  }, [fromTime.input.value, toTime.input.value]);

  return (
    <Grid container spacing={2}>
      <Grid item md={6} xs={12}>
        <CustomTimePickerInput
          source={fromSource}
          label={fromLabel}
          isError={isError}
        />
      </Grid>
      <Grid item md={6} xs={12}>
        <CustomTimePickerInput
          source={toSource}
          label={toLabel}
          isError={isError}
        />
      </Grid>
    </Grid>
  );
};

export default CustomTimeRangeInput;
